import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Grid
} from "@mui/material";
import React from "react";
import { OverViewSurveyor } from "../../Masters/LeadDetails/OverViewSurveyor";
import { OverViewCallContact } from "./OverViewCallContact";
import { OverViewDealsContact } from "./OverViewDealsContact";
import { OverViewEmailContact } from "./OverViewEmailContact";
import { OverViewEstimation } from "./OverViewEstimation";
import { OverViewMeetingContact } from "./OverViewMeetingContact";
import { OverViewNotesContact } from "./OverViewNotesContact";
import { OverViewPayment } from "./OverViewPayment";
import { OverViewProduct } from "./OverViewProduct";
import { OverViewQuotation } from "./OverViewQuotation";
import { OverViewTaskContact } from "./OverViewTaskContact";
import { OverViewWorkOrder } from "./OverViewWorkOrder";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { OverViewDocuments } from "./OverviewDocuments";
import { OverViewPartPayment } from "./OverViewPartPayment";
import { OverViewInvoices } from "./OverViewInvoices";
export const OverviewSectionContact: React.FC<any> = React.memo((props) => {


  return (
    <Grid
      sx={{
        borderRadius: 2,
        padding: 0,

      }}
    >
      <Grid
        sx={{
          border: "1px solid #ddd",
          borderRadius: 2,
        }}
      >

      </Grid>
      {/* <Accordion >
        <AccordionSummary expandIcon={<ExpandMoreIcon sx={{ color: 'white' }} />}>
          adsdasd
        </AccordionSummary>
        <AccordionDetails sx={{ mt: -2 }}>
          <OverViewSurveyor />
        </AccordionDetails>

      </Accordion> */}
      <Grid item sm={12} sx={{ marginTop: 0 }}>
        <OverViewSurveyor />
      </Grid>
      <br></br>
      <OverViewNotesContact />

      

      <OverViewEmailContact />
      <br></br>

      <OverViewCallContact />
      <br></br>

      <OverViewTaskContact />
      <br></br>

      <OverViewMeetingContact />
      

      {/* <OverViewDealsContact /> */}


      <OverViewProduct />


      <OverViewEstimation />


      <OverViewQuotation />
      
      <OverViewWorkOrder />
      <OverViewPayment />

      <br></br>
      <OverViewPartPayment />
      {/* <br></br> */}
      <OverViewInvoices />

      {/* <OverViewDocuments/> */}



      {/* <OverViewTasksContact /> */}

    </Grid>
  );
});
